/** Backend pagination envelope (see PagedResponse.java). */
export type Paged<T> = {
    items: T[];
    total: number;
    page: number;
    size: number;
};

export const PAGE_SIZE = 50;
